export enum CAR_URL_PARAM_KEYS {
  PICKUP_LOCATION = "pickupLocation",
  DROPOFF_LOCATION = "dropoffLocation",
  PICKUP_TIME = "pickupTime",
  DROPOFF_TIME = "dropoffTime",
  DROPOFF_DATETIME = "dropoffDateTime",
  PICKUP_DATETIME = "pickupDateTime",
  DRIVER_AGE = "driverAge",
  PRICE_RANGE_MIN = "priceMin",
  PRICE_RANGE_MAX = "priceMax",
  LAT_LNG = "latlng",
  ZOOM = "zoom",
  BOUNDS = "bounds",
  SORT_BY = "sortBy",
  VIEW = "view",
  SHOP_ID = "shopId",
  FILTERS = "filters",
}
